// extracted by mini-css-extract-plugin
module.exports = {"card":"F-card-card-2AA8v","cardHeader":"F-card-card-header-34LEn","cardFooter":"F-card-card-footer-3kCS7"};